/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.assistant.interactive.experience.rpc.BreezeAssistantPublicArtifactsRpc
 */

/**
 *  What a public viewer needs to run a shared presentation deck itself: the platform block bundle
 *  breeze-artifacts bundles, by source and sha256. The viewer builds the deck's read-only page from
 *  the shared content and runs it in a sandboxed, opaque-origin frame under its own policy. Empty
 *  when breeze-artifacts has none; the viewer then keeps its filmstrip.
 */

export const resolvePublicShareLinkRpc = {
  serviceName: 'com.hubspot.breeze.assistant.interactive.experience.rpc.BreezeAssistantPublicArtifactsRpc',
  rpcName: 'resolvePublicShareLink',
  auth: 'external',
  fingerprint: 'rgri-LZnbhsdSYpMut3uWnv9vlIdugMb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const exportPublicSharePptxRpc = {
  serviceName: 'com.hubspot.breeze.assistant.interactive.experience.rpc.BreezeAssistantPublicArtifactsRpc',
  rpcName: 'exportPublicSharePptx',
  auth: 'external',
  fingerprint: 'FZsJzRF6PGbn5DiNKxWVcXv9vlIdugMb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const exportPublicSharePdfRpc = {
  serviceName: 'com.hubspot.breeze.assistant.interactive.experience.rpc.BreezeAssistantPublicArtifactsRpc',
  rpcName: 'exportPublicSharePdf',
  auth: 'external',
  fingerprint: 'iFlqZqUev9dwwRxUzuno_Xv9vlIdugMb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicShareDeckRuntimeRpc = {
  serviceName: 'com.hubspot.breeze.assistant.interactive.experience.rpc.BreezeAssistantPublicArtifactsRpc',
  rpcName: 'getPublicShareDeckRuntime',
  auth: 'external',
  fingerprint: '16GVThmeRp7_hw7pwit19Hv9vlIdugMb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};